import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AreaOfStudyService from "../../src/Services/AreaOfStudy.service";
import AreaOfStudyTypeDomainService from "../../src/Domain/AreaOfStudyType/AreaOfStudyType.service";
/**
 * MajorLookup already exists and captures data from the Major domain. This lookup captures data from the Area Of Study domain.
 */
const AreaOfStudyMajorLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AreaOfStudyService.findByIds(
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            ids, AreaOfStudyTypeDomainService.MAJOR_ID);
        },
        fetchOptions: (query) => {
            return AreaOfStudyService.search({
                query,
                areaOfStudyTypeIds: [AreaOfStudyTypeDomainService.MAJOR_ID],
                active: true,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(major) {
            return _jsx("span", { children: major.name });
        },
    });
};
export default AreaOfStudyMajorLookup;
